/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */

import { GTMViewLookPayload } from '@/data/types/GTM';

export const getGTMViewLookEventData = async (payload: GTMViewLookPayload) => ({
	look_id: payload.look_id,
	look_name: payload.look_name,
	ecommerce: {
		items: payload.items.map((item) => ({
			item_id: item.partNumber,
			item_name: item.name,
			item_brand: item.manufacturer,
			price: item.productPrice?.offer,
			currency: item.productPrice.currency,
		})),
	},
});
